export default __webpack_public_path__ + "static/media/rectangle.c200c6ad.png";